import {
  ThemeUICSSObject,
  getColorsAndStatesByPath,
  responsive,
  spacing,
} from '@apia/theme';
/* IMPORT HERE */

const dataGrid: ThemeUICSSObject = {
  position: 'relative',
  height: '100%',
  resize: 'both',

  '&.grid__queryGrid': {
    overflow: 'auto',
  },

  '.grid__loading': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'palette.background.default',
  },
  '.grid__container': {
    backgroundColor: 'palette.background.default',
    border: `0.96px solid`,
    borderColor: 'palette.border.article',
    position: 'relative',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',

    '&.fullscreen': {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 'maximizedTables',
    },

    '.grid__wrap': {
      overflow: 'auto',
      height: '100%',
    },
    '.grid__table': {
      variant: 'layout.common.tables.datagrid',
      tableLayout: 'fixed',
      borderCollapse: 'collapse',
      '.grid__header': {
        ...getColorsAndStatesByPath('components.datagrid.header'),
        position: 'sticky',
        zIndex: 2,
        insetBlockStart: 0,
        tr: {
          transform: 'translateX(-1px)',
        },
        '.grid__header__cell': (theme) => ({
          py: responsive({ 0: 3, 4: 4 }),
          px: responsive({ 0: 5, 4: 6 }),
          textAlign: 'left',
          fontWeight: 'bold',
          wordBreak: 'break-word',
          position: 'sticky',
          userSelect: 'none',
          borderBottom: `1px solid`,
          borderBottomColor: theme.palette.darkenColor(
            theme.palette.border.ghost,
          ),
          verticalAlign: 'middle',
          textDecoration: 'underline',
          span: {
            textTransform: 'none',
          },
          'button:not(.header__cell__button):not(:disabled)': {
            position: 'absolute',
            right: '10px',
            top: 'calc(50% - 8px)',
          },
        }),
      },
      '.grid__row': () => ({
        position: 'sticky',
        '&.hidden': {
          display: 'none',
        },
      }),
      '.additional__column': {
        textAlign: 'center',
        '.additional__column__buttons': {
          display: 'flex',
          gap: spacing(3),
          justifyContent: 'center',
        },
      },
      '.grid__cell': () => ({
        '&.additional__column': {
          verticalAlign: 'middle',
        },
        '*': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        position: 'relative',
        cursor: 'pointer',
        p: spacing(2),
        verticalAlign: 'middle',
        '&.edit__icon__cell': {
          verticalAlign: 'top',
        },
        '.radioButton': {
          alignSelf: 'start',
          pl: spacing(4),
          li: {
            width: '200px',
            span: {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            },
          },
        },
        '.grid__cell__content': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          alignContent: 'center',
          flexWrap: 'nowrap',

          '& *': {
            img: { display: 'flex' },
            '&:not(.radio__field):not(.radio__field *):not(.select):not(.select *):not(.uploader-list__buttons):not(.uploader-list__buttons *)':
              { mx: 'auto' },
            '&:not(svg):not(.debug_info__button):not(.iconButton):not(label):not(.radio__field):not(.radio__field *):not(button):not(select):not(.file-icon):not(.uploaderFilesList__withMenuElement__buttons):not(.autocomplete__icons):not(.image__field)':
              { width: '100%' },
          },
          '.dateInput': { flexDirection: 'column' },
          '.uploader': {
            '.uploader-list': {
              '.uploader-list__buttons': {
                button: { mx: 0 },
              },
            },
          },
          '.checkbox': {
            textAlign: 'center',
          },
        },
      }),
      '.grid__cell__edit': (theme) => ({
        verticalAlign: 'middle',
        cursor: 'pointer',
        borderRight: '0.96px solid',
        borderBottom: '0.96px solid',
        ...theme.palette?.getOneState(
          { borderColor: theme.palette.border.article },
          'default',
        ),
        '.grid__edit-button': { m: spacing(3) },
      }),
      '.additionalCell': {
        position: 'sticky',
        left: 0,
        zIndex: 2,
        background: 'palette.background.default',
        borderRight: '1px solid',
        borderRightColor: 'palette.border.article',
        '.additionalCell__buttons': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: spacing(3),
        },
      },
      '.deleteRowButton': { display: 'none' },
    },
    '.grid__footer': (theme) => ({
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'stretch',
      alignItems: 'center',
      borderTop: '1px solid',
      borderTopColor: 'palette.border.section',
      '.grid__pagination__wrapper': {
        flexGrow: 1,
      },

      '& > div': {
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacing(3),
        p: spacing(3),
      },

      '.grid__pagination': {
        bg: 'transparent',
        alignSelf: 'center',
        width: '100%',

        'button.iconButton': {
          ...theme.palette.getStatesFromPath('buttons.outline'),
          color: 'palette.text.primary',
          border: 'none',
          backgroundColor: 'transparent',
        },

        'button.iconButton:disabled': {
          backgroundColor: 'transparent',
        },
      },
    }),
    'div.fieldWrapper[class]': {},
    'abbr.required[class]': {
      color: 'danger',
    },
  },
  '.passwordInput__representation': {
    background: 'transparent',
    border: 'none',
  },
  /* PREPEND HERE */
};

export default dataGrid;
